<template>
  <div>
    <CRow>
      <CCol lg="26">
         <CTableWrapper :items="getDevicesData()"
         v-on:row-clicked="(item, index) => updateRowSelected( item,index )"          
        >
          <template #header>
           <CIcon name="cil-grid"/>Propriétés
          </template>
        </CTableWrapper>
      </CCol>
    </CRow>
  </div>
</template>

<script>

//require('dotenv').config()
const APIURL = process.env.VUE_APP_API_URL

import CTableWrapper from './SNdevice.vue'
import axios from 'axios'

export default {
  name: 'SNDevices',
  data() {
    return {
      loading: true,
      rowSelected: -1,
      info: []
    }
  },  
  components: { 
          CTableWrapper 
  },
  mounted() {
       axios.get( APIURL+'/api1/devices', {   
         mode: 'no-cors',
              headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          withCredentials: false
        } )
        .then( res => { 
                this.info = res.data;                    
                for (var x=0; x < this.info.length; x++)
                {                   
                   if (this.$store.state.filterDevices.includes(this.info[x].serial))
                      this.info[x].filter = true;
                   else
                      this.info[x].filter = false;
                      
                }
              }
        )
        .catch( err => console.log(err))
        .finally(() => this.loading = false) 
  },
  methods: {
    getDevicesData() {
      return this.info;
    },
    updateRowSelected( item,row )            
    {
  //    console.log(item,row) 

    }
  }
}

</script>
